import React from 'react';
import UploadRestriction from './UploadRestriction';
import type { ToastContent } from './utils/useShowEditorToast';

const attachmentSizeExceededToast: ToastContent = {
  level: 'warning',
  title: 'Attachment too large',
  hideIcon: true,
  message: <UploadRestriction />,
  customButton: ({ onDismiss }) => (
    <UploadRestriction.UpgradeButton onClick={onDismiss} />
  ),
};

export default attachmentSizeExceededToast;
